import React from 'react';
import { Stat } from '../../../../../CommonComponents/OPL/Stat/Stat';

interface Props {
  label: string;
  value: string | null;
}
export const MarketValueContent = ({ label, value }: Props) => {
  return <Stat label={label} value={value || '–'} />;
};
